import {Component, Input} from '@angular/core';
import {GatewaySvgComponent} from "src/app/presentation/common/icons/gateway-svg/gateway-svg.component";

@Component({
  selector: 'app-water-point-marker',
  imports: [
    GatewaySvgComponent
  ],
  templateUrl: './gateway-marker.component.html',
  styleUrl: './gateway-marker.component.css'
})
export class GatewayMarkerComponent {

  @Input() iconName: string = '';
  @Input() status?: string;
}
